import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-4 pb-28 pt-10 sm:pb-24" data-id="element-152" data-mp="19j53j40hsmi0">
      <div className="mx-auto max-w-2xl text-center" data-id="element-153" data-mp="206j3niyycbee">
        <div className="flex items-center justify-center gap-2" data-id="element-154" data-mp="209x9j16tr2ql">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-forest-mid font-display text-lg font-bold text-white" data-id="element-155" data-mp="2f4bi07sritr0">
            K
          </span>
          <span className="font-display text-lg font-bold text-white" data-id="element-156" data-mp="1mfczh9kq9pl6">Dr. Karito</span>
        </div>
        <p className="mt-3 text-[13px] font-semibold text-white/70" data-id="element-157" data-mp="1hhunfabeyu8y">
          Clinical Kit for Obesity Management
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[12px] font-medium leading-relaxed text-white/45" data-id="element-158" data-mp="1w7ilm2oatcsg">
          Educational material intended for healthcare professionals. This resource does not replace
          clinical judgment, official prescribing information, or local clinical guidelines and
          regulations.
        </p>
        <p className="mt-5 text-[12px] font-medium text-white/40" data-id="element-159" data-mp="yoqy2158b3k5">
          © 2026 Dr. Karito. All Rights Reserved.
        </p>
      </div>
    </footer>;
}